export default [
  {
    header: 'Dashboards',
    icon: 'HomeIcon',
    children: [
      {
        title: 'eCommerce',
        route: 'dashboard-ecommerce',
        icon: 'ShoppingCartIcon',
      },
      {
        title: 'Analytics1',
        route: 'dashboard-analytics',
        icon: 'ActivityIcon',
      },
    ],
  },
]
